import HeaderMobile1 from './1/component';
import HeaderMobile2 from './2/component';
import HeaderMobile3 from './3/component';

const templates = {
	1: HeaderMobile1,
	2: HeaderMobile2,
	3: HeaderMobile3,
};

export default templates;

export function HeaderMobile(templateId = 1) {
	return templates[templateId]();
}
